import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 -mt-10 relative z-10">
      <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-9 gap-2 md:gap-3">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-1.5 p-3 md:p-4 rounded-lg bg-background-100 border border-background-300/30 hover:border-primary-500/40 hover:bg-background-200 transition-all duration-300"
          >
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-background-200 flex items-center justify-center group-hover:bg-primary-500/10 transition-colors">
              <i className={`${cat.icon} text-lg md:text-xl text-primary-500`}></i>
            </div>
            <span className="text-xs md:text-sm text-foreground-200 font-medium">{cat.name}</span>
            <span className="text-[10px] text-foreground-500">{cat.count}部</span>
          </Link>
        ))}
      </div>
    </section>
  );
}